import { UserIsInvalidException } from '@/domain/login/exceptions';
import { UnknowErrorException } from '@/domain/common/exceptions';

export const authenticateUserExecute = async (payload, userLogin) => {
  const {
    data: dataUser,
    status: statusLogin,
    responseCode,
    message,
  } = await userLogin(payload.platform, payload.request);
  if (statusLogin === 200 && responseCode === '00') {
    localStorage.setItem('token', dataUser.token);
    localStorage.setItem('userCode', dataUser.userCode);
    return { responseCode, dataUser };
  } else if (responseCode === '01' || responseCode === '02') {
    throw new UserIsInvalidException({ errorCode: responseCode, message });
  } else {
    throw new UnknowErrorException({
      errorCode: responseCode,
      message,
    });
  }
};
